import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export type EvidenceListQuery = {
  from?: string;
  to?: string;
  deviceId?: string;
  employee?: string;
  faceId?: string;
  logId?: string;
  flag?: string;
  page?: number;
  limit?: number;
};

const clean = (q: EvidenceListQuery) =>
  Object.fromEntries(Object.entries(q).filter(([, v]) => v !== "" && v !== undefined && v !== null));

export const EvidenceService = {
  list: (query: EvidenceListQuery) =>
    RequestUtil.get({ url: REQUEST_URL.ATTENDANCE_EVIDENCE, query: clean(query) }),

  detail: (id: string) =>
    RequestUtil.get({ url: `${REQUEST_URL.ATTENDANCE_EVIDENCE}/${id}` }),

  /** Video needs the Bearer header, so fetch as a blob (clips are ~50–600 KB). */
  video: (id: string) =>
    RequestUtil.send({
      method: "get",
      url: `${REQUEST_URL.ATTENDANCE_EVIDENCE}/${id}/video`,
      responseType: "blob",
      timeout: 60000,
    }),
};
